const ENTREPRISE_FORM_FIELDS_COMMON = {
    SIRET: 'siret',
    RAISON_SOCIALE: 'raisonSociale',
    DATE_CREATION: 'dateCreation',
    CODE_NAF: 'codeNaf',
    FORME_JURIDIQUE: 'formeJuridique',
    RUE: 'rue',
    CODE_POSTAL: 'codePostal',
    VILLE: 'ville',
    PAYS: 'pays',
    SIREN: 'siren',
    NB_SALARIES: 'nombreSalaries',
    DATE_CLOTURE_COMPTABLE: 'dateClotureComptable'
};

export const ENTREPRISE_FORM_FIELDS_EPARGNE = {
    ...ENTREPRISE_FORM_FIELDS_COMMON
}
